import { ACTIVE_SERVICE_TYPES, type ActiveServiceType, type ServiceType } from "./types";

export type ServiceDefinition = {
  label: string;
  description: string;
  purpose: string;
  deliverable: string;
  evidence: string;
  source: string;
  mobile: boolean;
};

/** Vocabulário único para contratação, navegação, pré-análise e entrega. */
export const SERVICE_DEFINITIONS: Record<ActiveServiceType, ServiceDefinition> = {
  reclassificacao_monta: {
    label: "Reclassificação de Monta",
    description: "Avalie a estrutura do veículo e documente a classificação técnica de monta.",
    purpose: "Inspeção estrutural com matriz aplicável, RT, CREA, ART e evidências por elemento.",
    deliverable: "Laudo de Reclassificação com inspeção, fotografias e revisão técnica.",
    evidence: "BAT/BO, classificação original, documentos do veículo e fotos de todos os elementos.",
    source: "Modelos documentais e internos de Reclassificação",
    mobile: true,
  },
  nexo_causal: {
    label: "Nexo Causal",
    description: "Examine a relação técnica entre o evento informado e os danos observados.",
    purpose: "Confrontar dinâmica, geometria, evidências e hipóteses, registrando limites da análise.",
    deliverable: "Parecer técnico de Nexo Causal, com fundamentação e conclusão.",
    evidence: "Relato do evento, registros, fotografias, mapa de danos e documentos relacionados.",
    source: "F02 e F06 — referência documental e de conferência",
    mobile: false,
  },
  sindicancia: {
    label: "Sindicância",
    description: "Apure as circunstâncias do sinistro e organize a consistência das informações.",
    purpose: "Documentar diligências, fontes consultadas, versões e achados, sem presumir fatos.",
    deliverable: "Relatório de Sindicância com diligências, achados e conclusão fundamentada.",
    evidence: "Documentos do sinistro, relatos, registros, comunicações e evidências de diligências.",
    source: "F02 e F06 — referência documental e de conferência",
    mobile: false,
  },
  orcamento_tecnico: {
    label: "Orçamento Técnico",
    description: "Estime e revise os custos de reparação com critérios técnicos e valores justificados.",
    purpose: "Discriminar itens, quantidades, custos propostos e decisões técnicas por item.",
    deliverable: "Orçamento Técnico consolidado com memória de valores e critérios de aprovação.",
    evidence: "Mapa de danos, propostas, referências de preços, peças e serviços necessários.",
    source: "F03 e F07 — referência documental e de conferência",
    mobile: false,
  },
};

export const LEGACY_SERVICE_LABELS: Partial<Record<ServiceType, string>> = {
  sindicancia_nexo: "Sindicância e Nexo Causal (histórico)",
  auditoria_danos_valores: "Auditoria de danos e valores (histórico)",
  pericia_bens_imoveis: "Perícia de bens imóveis (histórico)",
  auditoria_oficinas: "Auditoria de oficinas (histórico)",
};

export function isActiveService(type: string): type is ActiveServiceType {
  return (ACTIVE_SERVICE_TYPES as readonly string[]).includes(type);
}

export function serviceLabel(type: string): string {
  return isActiveService(type) ? SERVICE_DEFINITIONS[type].label : LEGACY_SERVICE_LABELS[type as ServiceType] ?? "Serviço histórico";
}
